import { SVG, SVGProps } from './svg'

export function IconCaretDown(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M6.2 10.5a.7.7 0 0 1 0-1l.3-.3L7 9h10c.2 0 .4 0 .5.2l.3.3a.7.7 0 0 1 0 1l-5.3 5.3a.7.7 0 0 1-1 0l-5.3-5.3Z" />
    </SVG>
  )
}
